import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import CfdiUso from './CfdiUso.js';
import ACCESS from '../../../ACCESS.js';

class CfdiUsos extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'cfdi-uso/filter', deleteUrl: 'cfdi-uso/delete', deleteField: 'cfdi_uso_nombre', modUrl: '/Catalogo/CfdiUso' },
      TableOp.Table('Usos CFDI', [
        { label: 'Clave', id: 'cfdi_uso_clave' },
        { label: 'Nombre', id: 'cfdi_uso_nombre' },
        { label: 'Fisica', id: 'cfdi_uso_fisica' },
        { label: 'Moral', id: 'cfdi_uso_moral' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_USOS_CFDI.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_USOS_CFDI.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <CfdiUso  onSave={() => {this.table()}}></CfdiUso>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(CfdiUsos)